
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_QHSES: (state, payload) => state.qhses = payload,

}